var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(-1832 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    transform: "translate(1832 687)",
    fill: "rgba(0,0,0,0.62)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios-24px",
    transform: "translate(1896.821 751.497) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M0,0H58.319V58.318H0Z",
    fill: "none",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M25.2.893a3.036,3.036,0,0,0-4.3,0L.711,21.085a2.42,2.42,0,0,0,0,3.426L20.9,44.7a3.041,3.041,0,0,0,4.3-4.3L7.612,22.786,25.229,5.17A3.029,3.029,0,0,0,25.2.893Z",
    transform: "translate(15.181 6.372)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRightArrow);
export default __webpack_public_path__ + "static/media/video-right-arrow.52d7a2df.svg";
export { ForwardRef as ReactComponent };